import { useMemo, useState } from 'react'
import { useSelector } from 'react-redux'

import { selectProjectIdentity } from '@store/actionSlices/projectIdentity'
import { selectShortlist } from '@store/actionSlices/shortlist'
import { ShortlistPropertyType, UnitShortlistInterface } from '@store/types'

import ShortlistHandler from '@utilities/shortlist-handler'

import { notifyError } from '@adUtilities/notifier'
import { Unit } from '@adUtilities/types/apartment'

const useUnitShortlist = (unit: Unit) => {
  const shortlist = useSelector(selectShortlist)
  const projectIdentity = useSelector(selectProjectIdentity)
  const [removeShortlistProperty, setRemoveShortlistProperty] = useState(false)

  const property = useMemo<UnitShortlistInterface>(
    () => ({
      propertyId: unit.id,
      propertyName: unit.name,
      references: {
        blockId: unit.blockId,
        levelId: unit.metas.level,
      },
      type: ShortlistPropertyType.Unit,
    }),
    [unit]
  )

  const [isShortlisted, toggleShortlist] = ShortlistHandler({
    property,
    shortlist,
    setShortlistErrorMessage: notifyError,
    projectIdentity,
    toggleConfirmModal: setRemoveShortlistProperty,
    removeShortlistProperty,
    setRemoveShortlistProperty,
    available: unit.metas.status,
  })

  return { isShortlisted, toggleShortlist }
}

export default useUnitShortlist
